import { DATE_TIME_FORMATS } from '@nandosaus/constants';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';

import { mapSpacedData } from '../../../utils/tables';
import { SpacedTable } from '../../table-template/spaced-table';

const RestaurantOpeningHoursTable = ({ openingHours, formattedTradingHours }) => {
  const openingHoursData = openingHours.map(({ day, openingTime, closingTime }) => {
    // TODO: Handle Public Holidays
    const isToday = dayjs().format(DATE_TIME_FORMATS.TIME_FULL_DAY) === day;

    const time = formattedTradingHours({ closingTime, openingTime });
    return mapSpacedData(day, time, isToday, isToday);
  });

  return <SpacedTable data={openingHoursData} headers={['Opening Hours']} />;
};

RestaurantOpeningHoursTable.propTypes = {
  openingHours: PropTypes.arrayOf(
    PropTypes.shape({
      closingTime: PropTypes.string.isRequired,
      day: PropTypes.string.isRequired,
      openingTime: PropTypes.string.isRequired,
    })
  ).isRequired,
  formattedTradingHours: PropTypes.func.isRequired,
};

export { RestaurantOpeningHoursTable };
